/**
 * カードの画像の一部を拡大して出す（スキャンした画像からカード ID・型番を読むため。Issue #928）。
 * 領域は画像の幅・高さに対する割合。位置は OCG のカード（59 × 86 mm）の実物のスキャンで測った。
 */

const CARD_ASPECT = 1080 / 743;   // 高さ / 幅（スキャンした画像）

export const CARD_REGIONS = {
  passcode: { x: 0, y: 0.94, w: 0.25, h: 0.06 },     // 左下のカード ID
  setCode:  { x: 0.6, y: 0.71, w: 0.38, h: 0.06 },   // 絵の枠の右下の型番（SD01-JP001 など）
};

export default function CardRegionZoom({ src, region, width = 200, title, label, testId }) {
  const { x, y, w, h } = region;
  const zoom = (
    <div
      data-testid={testId}
      title={title}
      style={{
        width, height: Math.round(width * (h / w) * CARD_ASPECT), flexShrink: 0, borderRadius: 4,
        backgroundImage: `url(${src})`,
        backgroundSize: `${100 / w}% auto`,
        backgroundPosition: `${w < 1 ? (x / (1 - w)) * 100 : 0}% ${h < 1 ? (y / (1 - h)) * 100 : 0}%`,
        backgroundRepeat: 'no-repeat',
        border: '1px solid #444',
      }}
    />
  );
  if (!label) return zoom;
  return (
    <figure style={{ margin: 0, flexShrink: 0 }}>
      <figcaption style={{ fontSize: '0.7rem', color: '#aaa', marginBottom: 2 }}>{label}</figcaption>
      {zoom}
    </figure>
  );
}
